import { render, staticRenderFns } from "./group.vue?vue&type=template&id=6132d9f4"
import script from "./group.vue?vue&type=script&lang=ts"
export * from "./group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports